
import React from 'react';
import WaterPressureChart from './WaterPressureChart';
import WaterFlowChart from './WaterFlowChart';

const WaterQualityTab = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <WaterPressureChart />
      <WaterFlowChart />
    </div>
  );
};

export default WaterQualityTab;
